import { constants } from '@saucelabs/sl-module-organization';

export const toggleSetValue = (item, value) => (
  item.has(value) ? item.remove(value) : item.add(value)
);

export const modify = (state, key, callback) => {
  const path = Array.isArray(key) ? key : [key];
  return state.setIn(path, callback(state.getIn(path)));
};

export const isValidSsoXml = (xmlFile) => (
  new RegExp(constants.ENTITY_ID_RE).test(xmlFile) &&
  new RegExp(constants.X509CERTIFICATE_RE).test(xmlFile)
);

export const haveAccessToMultipleTeams = (user) => {
  const teamNavigationEnabled = user.get('organization', {})?.team_navigation_enabled || false;
  return teamNavigationEnabled;
};

export const parseAssignedTeamsErrorResponse = (response) => {
  const teamsError = response.data?.teams || response.data?.team;
  if (teamsError?.non_field_errors) {
    return teamsError.non_field_errors.join(' ');
  }

  if (Array.isArray(teamsError)) {
    return teamsError.join(' ');
  }

  return response?.data?.message || response?.data?.detail;
};
